import ViewRaportyList from "../../components/views/raporty/reporter/ViewRaportyList/ViewRaportyList.jsx";
import ViewRaportForm from "../../components/views/raporty/reporter/ViewRaportForm/ViewRaportForm.jsx";

export const raportyRoutes = [
    {
        path: '/reporter/raporty',
        exact: true,
        roles: ['raporty_podglad'],
        forbidden: true,
        view: <ViewRaportyList/>,
        mode: 'all'
    },
    {
        path: '/reporter/raporty/:id',
        exact: true,
        roles: ['raporty_podglad'],
        forbidden: true,
        view: <ViewRaportForm/>,
        mode: 'all'
    },
]